export default "__VITE_ASSET__B_h7ThEo__"